import React, {MouseEvent} from "react";
import EmptyModal from "./emptyModal";
import { useHistory } from "react-router"

export default function LogoutModal() {
	const history = useHistory();

	const onLogout = (e: MouseEvent) => {
		e.preventDefault();
		($("#logoutModal") as any).modal('hide');
		localStorage.removeItem("TOKEN");
		history.push("/login")
	}

	const buttons = (
		<React.Fragment>
			<button className="btn btn-secondary" type="button" data-dismiss="modal">
				Cancel
			</button>
			<a className="btn btn-primary" href="login" onClick={onLogout}>
				Logout
			</a>
		</React.Fragment>
	);
	return (
		<EmptyModal
			id="logoutModal"
			title="Ready To Leave?"
			message='Select "Logout" below if you are ready to end your current session'
			buttons={buttons}
		/>
	);
}

export const popup = () => {
	($("#logoutModal") as any).modal();
	return;
};
